import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Assumptions } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-actuarial-assumptions-info',
  templateUrl: './actuarial-assumptions-info.component.html',
  styleUrls: ['./actuarial-assumptions-info.component.scss']
})
export class ActuarialAssumptionsInfoComponent implements OnInit{
  private destroy$ = new Subject<void>();
  assumptions!: Assumptions;


  constructor(private userService: UserService) {
  }

  ngOnInit(): void {
    this.userService.assumptions$
      .pipe(takeUntil(this.destroy$))
        .subscribe((assumptions) => {
          this.assumptions = assumptions;
        });
  }

}
